import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { Href, Purchase, SimplePricingCards } from "../../../Constant";
import { Btn, H1, H3, H4 } from "../../../AbstractElements";
import { SIMPLE_PRICING_DATA } from "../../../Data/Ecommerce";

const SimplePricingCard = () => {
  return (
    <Card>
      <CommonCardHeader title={SimplePricingCards} />
      <CardBody>
        <Row className="g-sm-4 g-3">
          {SIMPLE_PRICING_DATA.map((item, index) => (
            <Col lg="3" sm="6" className="box-col-3" key={index}>
              <Card className="text-center pricing-simple">
                <CardBody>
                  <H3>{item.title}</H3>
                  <H1>${item.price}</H1>
                  <H4 className="f-w-700 mb-0">{item.plan}</H4>
                </CardBody>
                <Btn as="a" color="primary" size="lg" className="btn-block" href={Href}>{Purchase}</Btn>
              </Card>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};

export default SimplePricingCard;
